import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { FixedWidth } from 'ui/utility/fixedWidth';
import { SupportedMediums } from 'modules/frequencyManagement/lib/types';
import { SummaryBannerLoading } from '../../lib/components/summaryBanner/SummaryBannerLoading';
import { MessageTypesCardLoading } from '../messageType/MessageTypesCardLoading';
import { MessageMediumCardLoading } from '../messageMedium/MessageMediumCardLoading';

const Wrapper = styled.div`
  & > *:not(:first-child) {
    margin-top: ${spacing.double};
  }
`;

export const Loading = ({ messageMedium }: { messageMedium: SupportedMediums }) => (
  <FixedWidth>
    <Wrapper>
      <SummaryBannerLoading />
      <MessageMediumCardLoading messageMedium={messageMedium} />
      <MessageTypesCardLoading messageMedium={messageMedium} />
    </Wrapper>
  </FixedWidth>
);
